import styled from "styled-components";

export const NudgeBotMessageCloud = styled.div<{ isLAMessage?: boolean }>`
  ${(props) => props?.theme?.themeConfig?.nudge?.botMessage?.cloud?.styles}

  -webkit-line-clamp: ${(props) => props.isLAMessage ? 'initial' : 2};
`;